import {z} from 'zod'
export const imageMock = new URL('./mockImage.png', import.meta.url).href

export const defaultValues = {
  tierID: '',
  name: '',
  country: 'MX',
  active: true,
  activities: [
    {
      activityID: '',
      activityName: '',
      multiplier: 1.0,
    },
  ],
  content: {
    'es-MX': {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      detailsDescription: '',
      detailsTermsAndConditions: '',
      detailsImage: '',
    },
    'en-US': {
      tierName: '',
      displayDescription: '',
      imageTierIcon: '',
      bannerHeader: '',
      bannerDescription: '',
      bannerImage: '',
      detailsDescription: '',
      detailsTermsAndConditions: '',
      detailsImage: '',
    },
  },
}

const displayItemSchema = z.object({
  tierName: z.string(),
  displayDescription: z.string().optional(),
  imageTierIcon: z.string(),
  bannerHeader: z.string(),
  bannerDescription: z.string().optional(),
  bannerImage: z.string(),
  detailsDescription: z.string(),
  detailsTermsAndConditions: z.string().optional(),
  detailsImage: z.string(),
})

export const activityItemSchema = z.object({
  activityID: z.string(),
  activityName: z.string(),
  multiplier: z.number(),
})

export const createTierSchema = z.object({
  tierID: z.string(),
  name: z.string(),
  country: z.string(),
  active: z.boolean(),
  activities: z.array(activityItemSchema).min(1),
  content: {
    'en-US': displayItemSchema,
    'es-MX': displayItemSchema,
  },
})

export const mockReview = {
  tierID: 'Platinum',
  activities: [
    {
      activityID: '1',
      activityName: 'Activity 1',
      multiplier: 1.5,
    },
    {
      activityID: '2',
      activityName: 'Activity 2',
      multiplier: 3.5,
    },
  ],
  content: {
    'es-MX': {
      tierName: 'Platinum',
      displayDescription: 'Gana recompensas con actividades.',
      imageTierIcon: imageMock,
      bannerHeader: '¡Bienvenido al Oro!',
      bannerDescription: 'Beneficios exclusivos para ti.',
      bannerImage: imageMock,
      detailsDescription: 'Completa tareas y encuestas para ganar puntos.',
      detailsTermsAndConditions: 'Aplican términos y condiciones.',
      detailsImage: imageMock,
    },
    'en-US': {
      tierName: 'Platinum',
      displayDescription: 'Earn rewards with activities.',
      imageTierIcon: imageMock,
      bannerHeader: 'Welcome to Gold!',
      bannerDescription: 'Exclusive benefits for you.',
      bannerImage: imageMock,
      detailsDescription: 'Complete tasks and surveys to earn points.',
      detailsTermsAndConditions: 'Terms and conditions apply.',
      detailsImage: imageMock,
    },
  },
}
